import {Button} from "@mui/material";
import React from "react";

const ButtonPrimary = (props) => {
    return (
        <Button {...props} variant="contained" color= "primary" className={`comp-button button-main-new ${props.className ? props.className : ''}`} />
    );
}
export {ButtonPrimary};